/**
 * Gets the currently focused element, taking shadow roots into account.
 */
export function getFocusedElement(root: Document | ShadowRoot): Element | undefined {
  if (root.activeElement?.shadowRoot) {
    return getFocusedElement(root.activeElement.shadowRoot)
  }

  return root.activeElement || undefined
}

/**
 * Returns `true` when the element is one the user types into: a native form
 * field (`input`, `textarea`, `select`) or a `contenteditable` region.
 *
 * Pair with `getFocusedElement(document)` to resolve the deep active element
 * through shadow roots first, so Nord's own inputs (e.g. `nord-input`) are
 * detected via their inner native field. Used to suppress global shortcuts
 * while the user is editing text.
 */
export function isEditableElement(element: Element | null | undefined): boolean {
  if (!element) {
    return false
  }

  const tagName = element.tagName
  if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
    return true
  }

  return (element as HTMLElement).isContentEditable
}
